import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ArrowRightCircle = ({ className }) => {
  return (
    <svg
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-arrow-right-circle', { [className]: className })}
    >
      <path
        d='M11.6036 8.35355C11.7988 8.15829 11.7988 7.84171 11.6036 7.64645L8.42157 4.46447C8.22631 4.2692 7.90973 4.2692 7.71447 4.46447C7.5192 4.65973 7.5192 4.97631 7.71447 5.17157L10.5429 8L7.71447 10.8284C7.5192 11.0237 7.5192 11.3403 7.71447 11.5355C7.90973 11.7308 8.22631 11.7308 8.42157 11.5355L11.6036 8.35355ZM0 8.5H11.25V7.5H0V8.5Z'
        fill='currentColor'
      />
      <circle cx='7.5' cy='8' r='7' stroke='currentColor' />
    </svg>
  );
};

ArrowRightCircle.propTypes = {
  className: PropTypes.string,
};

export default ArrowRightCircle;
